import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithErrorHandling from './baseQuery';
import { Constants } from '../constants/Constants';

const { BASE_API_URL } = Constants;

export interface NrtPostRequestBody {
    vehicles: string[];
}

export type DataFormat = 'CSV' | 'JSON';

interface NrtActivationResponse {
    active: boolean;
    last_activity_date?: string;
}

export const nrtApi = createApi({
    reducerPath: 'nrtApi',
    baseQuery: baseQueryWithErrorHandling({ baseUrl: BASE_API_URL }),
    endpoints: builder => ({
        downloadNrtData: builder.mutation<Blob, { data: NrtPostRequestBody; format: DataFormat }>({
            query: ({ data, format }) => ({
                url: `/current/download/${format}`,
                method: 'POST',
                body: {
                    ...data,
                    ownership_consent: 'consented',
                },
                // override default headers if needed:
                headers: {
                    Accept: 'application/octet-stream',
                },
                responseHandler: response => {
                    if (!response.ok) {
                        // let RTK Query handle errors
                        throw new Error(`Download failed: ${response.statusText}`);
                    }
                    return response.blob();
                },
            }),
            transformResponse: (response: Blob) => response,
        }),
        activateNrt: builder.query<NrtActivationResponse, void>({
            query: () => ({
                url: '/current/activation',
                method: 'GET',
            }),
        }),
        activateNrtMutation: builder.mutation<NrtActivationResponse, void>({
            query: () => ({
                url: '/current/activation',
                method: 'POST',
            }),
        }),
    }),
});

// Export the hooks
export const { useDownloadNrtDataMutation, useActivateNrtQuery, useActivateNrtMutationMutation } = nrtApi;
